export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.special_project) {
        return {...state, ...payload.special_project};
      }
      return state;
    }
  }
};
